
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.69 2.413v5.312a.94.94 0 00.937.938h5.312v12.812c0 .52-.418.938-.937.938H5.877a.935.935 0 01-.938-.938V3.35c0-.52.418-.937.938-.937h7.813zm2.152.273l3.824 3.828a.934.934 0 01.273.66v.239h-5v-5h.239c.25 0 .488.097.664.273zM8.204 15.095l3.766-3.739a.666.666 0 01.939 0l3.766 3.739a.625.625 0 01-.439 1.068H13.69v3.125c0 .346-.28.625-.625.625h-1.25a.625.625 0 01-.625-.625v-3.125H8.644a.625.625 0 01-.44-1.068z","fill":"#191F2D"}})])
          )
        }
      }
    